import Vue from 'vue';
import Router from 'vue-router';
import Error404 from '@/views/Error404';
// import Home from './views/Home.vue';
// import modules from '@/modules';

// Generate an array of routes from the module list.
// const a_module_routes = (function(){
//    var n, a = [];
//    for( n in modules ){
//       a = a.concat( modules[ n ].routes );
//    }
//    return a;
// }());

Vue.use(Router);

export default new Router({
   mode: 'history',
   routes: [
      {
         path: '/',
         name: 'home',
         //component: Home
         component: () => import('@/views/Default'), //jshint ignore:line
      },

      {
         path: '/services',
         name: 'services',
         //component: Home
         component: () => import('@/views/Services'), //jshint ignore:line
      },

      {
         path: '/products',
         name: 'products',
         //component: Home
         component: () => import('@/views/Products'), //jshint ignore:line
      },

      {
         path: '/about',
         name: 'about',
         //component: Home
         component: () => import('@/views/About'), //jshint ignore:line
      },

      {
         path: '/gift_certificate',
         name: 'gift_certificate',
         //component: Home
         component: () => import('@/views/GiftCertificate'), //jshint ignore:line
      },

      {
         path: '/appointment',
         name: 'appointment',
         //component: Home
         component: () => import('@/views/Appointment'), //jshint ignore:line
      },

      {
         path: '/contact',
         name: 'contact',
         //component: Home
         component: () => import('@/views/Contact'), //jshint ignore:line
      },

      // Insert the module routes before the default 404 error route.
      // ...a_module_routes,

      {
         path: '*',
         component: Error404
      }
   ]
});
